import { useContext } from 'react';
import useNRQuery from '../../graphql/useNRQuery';
import ActivityFeedContent from './NRActivityFeedContent';
import { ComponentContext } from '../../ContextWrappers/NRComponentContextWrapper';
import { GET_ACTIVITY } from '../../graphql/queries/asset';

function NRActivityFeedContainer({ handleClose }) {
  const { asset } = useContext(ComponentContext);

  const [assetActivity, loadingGetAssetActivity] = useNRQuery({
    query: GET_ACTIVITY,
    options: {
      context: { version: 'v3' },
      fetchPolicy: 'no-cache',
      variables: {
        args: {
          cursor: { first: 10000 },
          assetId: asset?.id
        }
      }
    },
    qlObjKey: 'activity',
    defaultValue: [],
    transformData: data => {
      const toReturn = data?.edges?.map(item => item.node);
      return toReturn;
    }
  });

  return (
    <ActivityFeedContent
      exportToCsvConfig={{
        qlArgs: {
          assetId: asset?.id
        }
      }}
      handleClose={handleClose}
      activity={assetActivity}
      isLoading={loadingGetAssetActivity}
    />
  );
}
export default NRActivityFeedContainer;
